import SettingsHeader from '../settings-header/SettingsHeader'
import {Booking} from "@/services/booking.service";
import { SortedTable, SortLink } from 'vue-sorted-table'
import {Location} from "@/services/location.service";
import router from "@/router";

export default {
    name: 'OpeningHoursViolations',
    components: {
        SettingsHeader,
        SortedTable,
        SortLink,
    },

    props: {
       value: Array,
       location: Location
    },

    created() {
        this.bookings = this.value ? this.value : undefined
    },

    data() {
        return {
            bookings: Array,
        }
    },

    mounted() {

    },

    methods: {
        selectRow(booking) {
            router.push(`/booking/${booking.id}`)

        }
    }

}
